import { render } from "./PaymentButtons.vue?vue&type=template&id=10b49b8e&ts=true"
import script from "./PaymentButtons.vue?vue&type=script&lang=ts"
export * from "./PaymentButtons.vue?vue&type=script&lang=ts"

import "./PaymentButtons.vue?vue&type=style&index=0&id=10b49b8e&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__